<ion-header class="ion-no-border" mode="ios">
  <ion-toolbar class="ion-padding">
    <ion-button class="ion-no-padding" slot="start" fill="clear" size="small" (click)="close()">
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-button>
    <ion-title class="fs-18 font-medium">{{ 'pages.quotes.supplyEntries.createModal.title' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content mode="ios" class="ion-padding-2">
  <div class="flex flex-column min-height-100">
    <span class="ion-text-uppercase font-medium">{{ 'pages.quotes.supplyEntries.createModal.quantityForm.title' | translate }}</span>
    <p class="font-regular">{{ 'pages.quotes.supplyEntries.createModal.quantityForm.description' | translate }}</p>
    <ui-date-picker
      [placeholder]="'pages.quotes.supplyEntries.createModal.quantityForm.date' | translate"
      [selectedDate]="selectedDate"
      (dateChange)="onDateChange($event)"
      [readonly]="isReadOnly"
    ></ui-date-picker>

    <ion-radio-group [(ngModel)]="isTotalDelivery" class="flex ion-margin-top">
      <ion-item lines="none" class="ion-no-padding" mode="md">
        <ion-label class="font-regular">{{ 'pages.quotes.supplyEntries.createModal.quantityForm.totalDelivery' | translate }} </ion-label>
        <ion-radio slot="start" [value]="true" [disabled]="isReadOnly && !isTotalDelivery"></ion-radio>
      </ion-item>

      <ion-item lines="none" class="ion-no-padding" mode="md">
        <ion-label class="font-regular">{{ 'pages.quotes.supplyEntries.createModal.quantityForm.partialDelivery' | translate }} </ion-label>
        <ion-radio slot="start" [value]="false" [disabled]="isReadOnly && isTotalDelivery"></ion-radio>
      </ion-item>
    </ion-radio-group>

    <ion-item class="ion-margin-top ion-no-padding ion-margin-bottom">
      <ion-label position="floating" color="medium">
        {{ 'pages.quotes.supplyEntries.createModal.quantityForm.quantity' | translate }}
      </ion-label>
      <ion-input type="number" [min]="1" [max]="maxOrders" [(ngModel)]="quantity" [readonly]="isReadOnly"></ion-input>
    </ion-item>
    <br />
    <span class="font-medium ion-padding-top block"
      >{{ 'pages.quotes.supplyEntries.createModal.attachment.title' | translate | uppercase }}
      {{ 'pages.quotes.supplyEntries.createModal.attachment.description' | translate }}</span
    >
    <div class="ion-margin-top">
      <ui-file-input (attachment)="onAttach($event)" [readonly]="isReadOnly" [value]="attachment"></ui-file-input>
    </div>

    <ui-bottom-actions>
      <ion-button class="w-full" (click)="save()" [disabled]="!isFormValid" *ngIf="!isReadOnly">
        {{ 'pages.quotes.supplyEntries.createModal.submit' | translate }}
      </ion-button>
      <ion-button class="w-full" (click)="delete()" fill="clear" *ngIf="isReadOnly" [disabled]="disableDelete">
        <ion-icon name="trash-outline"></ion-icon>
        &nbsp;
        {{ 'pages.quotes.supplyEntries.createModal.delete' | translate }}
      </ion-button>
    </ui-bottom-actions>
  </div>
</ion-content>
